import { DataSource } from "@seriously-rad/seriouslyrad-framework-core/Data/DataSource";
import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { WebApiClientService } from "@seriously-rad/seriouslyrad-framework-core/Server/WebApiClientService";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { ButtonStyleEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ButtonStyleEnum";
import { IMessageDialog, MessageDialog } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/MessageDialog";
import { DialogResultEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Dialogs/DialogResultEnum";

export type EntityCommandLocalAuthorityInvoiceRunFinalisePropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandLocalAuthorityInvoiceRunFinaliseProperties = {
    [name in keyof EntityCommandLocalAuthorityInvoiceRunFinalisePropertyValues]: Property<EntityCommandLocalAuthorityInvoiceRunFinalisePropertyValues[name]>
};

export interface IEntityCommandLocalAuthorityInvoiceRunFinalise extends IEntityCommand, EntityCommandLocalAuthorityInvoiceRunFinaliseProperties
{
}

export class EntityCommandLocalAuthorityInvoiceRunFinalise extends EntityCommand implements IEntityCommandLocalAuthorityInvoiceRunFinalise
{
    // #region Static

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandLocalAuthorityInvoiceRunFinalisePropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Finalise",
                entityName: "LocalAuthorityInvoiceRun",
                key: "LOCALAUTHORITYINVOICERUN_FINALISE",
                permission: PermissionEvaluator.permissionLevels.update,
                type: EntityCommandTypeEnum.entity
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Global Variables

    private messageDialog?: IMessageDialog;

    // #endregion

    // #region Overrides

    protected override async _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        await super._executeAsync(entityCommandInformation, value);

        if (!this.messageDialog)
            this.messageDialog = new MessageDialog();

        const
            entitySetName = entityCommandInformation.entitySetName.get(),
            record = entityCommandInformation.record.get();

        if (!entitySetName)
            return;

        if (!record || !record.id)
            return;

        this.messageDialog.buttonStyle.set(ButtonStyleEnum.yesNo);
        this.messageDialog.title.set("Finalise Invoice Run?");
        this.messageDialog.text.set("Are you sure you want to finalise this invoice run?");

        const
            result = await this.messageDialog.openAsync();

        if (result.dialogResult === DialogResultEnum.yes)
        {
            const
                webApiClient = ServiceManager.getRequired(WebApiClientService),
                data = await webApiClient.createEntityGetRequest(entitySetName, record.id, ["id", "rowVersion", "statusLookupItemId"]).executeAsync(),
                dataSource = new DataSource({ data });

            dataSource.propertyValueByPathSet("statusLookupItemId", "bac3b0a9-f253-415c-9989-058b8f878bf1");

            await (
                webApiClient
                    .createEntitySaveRequest(
                        entitySetName,
                        dataSource.data.get(),
                        dataSource.dataOriginal.get()
                    )
                    .executeAsync()
            );
        }
    }

    // #endregion

    // #endregion
}

